import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ESigningOrderType } from 'core/dto';
import { Subject, filter, map, take } from 'rxjs';
import { IActivity } from '../../../../dto-map/i-activity';
import { SignProcessWizardService } from '../../../../sign-process-wizard.service';
import { ActivityCollectionService } from '../../activity-collection/activity-collection.service';
import { ActivityItemService } from '../../activity-collection/activity-item/activity-item.service';
import { SelectActivitiesStepService } from '../../select-activities-step.service';

@Component({
  selector: 'ss-activity-item-unordered',
  templateUrl: './activity-item-unordered.component.html',
  styleUrls: ['./activity-item-unordered.component.css'],
  providers: [
    ActivityItemService
  ],
  host: {
    class: 'padding-standard padding-none-bottom flex-column background-white'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityItemUnorderedComponent {

  private readonly _destroy = new Subject<void>();
  readonly ITEM_HEIGHT = 75;

  private _activity!: IActivity
  @Input() get activity() {
    return this._activity;
  }
  set activity(value) {
    this._activity = value;
    this._changeDetectorRef.detectChanges();
  }

  readonly activityIdSubject = this._activityItemService.activityIdSubject;
  @Input() get activityId() {
    return this.activityIdSubject.value;
  }
  set activityId(value) {
    this.activityIdSubject.next(value);
  }



  readonly splugInfoOpenedSubject = this._activityItemService.splugInfoOpenedSubject;
  readonly mainFormGroupSubject = this._activityItemService.mainFormGroupSubject;
  readonly activitiesSubject = this._activityCollectionService.activitiesSubject;
  readonly showErrorObs = this._activityItemService.showErrorObs;
  readonly moveSubject = this._activityCollectionService.moveSubject;


  readonly showIdxObs = this._signProcessWizardService.processSigningOrderSubject.pipe(
    map((signingOrder) => signingOrder === ESigningOrderType.serial)
  )

  constructor(
    private _activityCollectionService: ActivityCollectionService,
    private _activityItemService: ActivityItemService,
    private _selectActivitiesStepService: SelectActivitiesStepService,
    private _changeDetectorRef: ChangeDetectorRef,
    private readonly _signProcessWizardService: SignProcessWizardService
  ) {


    this.mainFormGroupSubject
      .pipe(
        filter(Boolean),
        take(1)
      )
      .subscribe((mainFormGroup) =>

        this._selectActivitiesStepService.addForm(mainFormGroup)
      )

  }

  ngOnInit(): void {

  }



  removeActivity() {

    this._activityCollectionService.remove(this.activityId || '');

    const mainFormGroup = this.mainFormGroupSubject.value;
    this._selectActivitiesStepService.removeForm(mainFormGroup);
  }


  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();

    this._selectActivitiesStepService.removeForm(this.mainFormGroupSubject.value);

  }
}
